import React, { useState } from "react";
import { Button } from "../../components/template";

const quizData = {
  title: "Body Tox Level Assessment",
  description:
    "With the given level of pollution, poor dietary and lifestyle choices, we keep accumulating Toxins in our body which affects our energy and overall well-being. This quick test helps assess the level of Ama (toxins) in your body. Take the test now!",
  instructions: "Take the test now!",
};

const questions = [
  { category: "Digestive Tract", question: "How often do you feel nauseous or vomit?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "How often do you have loose stools or Diarrhea?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "How often do you experience constipation?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "Do you frequently feel bloated or burp a lot?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "How often do you get heartburn or foul-smelling gas?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Digestive Tract", question: "Do you experience stomach or intestinal pain regularly?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Head", question: "How often do you get headaches?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Head", question: "Do you ever feel faint or lightheaded?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Head", question: "How often do you experience dizziness?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Head", question: "Do you have trouble falling or staying asleep?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Joints / Muscles", question: "Do you feel aches or pain in your joints?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Joints / Muscles", question: "Do your joints feel stiff or arthritic often?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Joints / Muscles", question: "How often do you feel muscle aches or tension?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Joints / Muscles", question: "Do you regularly feel physically weak or low on strength?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Energy / Activity", question: "Do you often feel tired or sluggish?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Energy / Activity", question: "How often do you feel restless or unable to sit still?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Energy / Activity", question: "Do you feel the need to urinate frequently or urgently?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Ears & Eyes", question: "Do your eyes or ears feel itchy often?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Do you get earaches or ear infections regularly?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Is there any fluid or discharge from your ears?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Do you hear ringing in your ears?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Have you noticed any hearing or vision loss?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Ears & Eyes", question: "Do you have excessive earwax or discharge?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Mouth / Throat", question: "Do you have a persistent cough?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Mouth / Throat", question: "How often do you get a sore throat or feel hoarse?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Mouth / Throat", question: "Is there any discoloration on your tongue, gums, or lips?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Skin", question: "Do you have acne or dandruff?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Skin", question: "How often do you get hives, rashes, or very dry skin?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Skin", question: "Have you experienced unusual hair loss?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },

  { category: "Nose", question: "Do you often have a stuffy nose or too much mucus?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Nose", question: "How often do you get sneezing fits or hay fever?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Nose", question: "Do you experience nosebleeds often?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
  { category: "Nose", question: "Do you have a reduced sense of smell?", options: ["Never/rarely", "Occasionally, but not severe", "Occasionally, but severe", "Frequently, but not severe", "Frequently, but severe"] },
];

const BodyToxinQuiz = () => {
  const [page, setPage] = useState(0);
  const [answers, setAnswers] = useState({});
  const [score, setScore] = useState(0);
  const [error, setError] = useState(""); // Error message state

  const handleOptionChange = (question, value) => {
    setAnswers((prevAnswers) => ({ ...prevAnswers, [question]: value }));
    setError(""); // Clear any error message when an option is selected
  };

  const handleNext = () => {
    // Check if an answer exists for the current question before proceeding
    if (answers[questions[page - 1]?.question] === undefined) {
      setError("Please select an option to proceed.");
      return;
    }
    setError(""); // Clear error if validation passes
    setPage(page + 1);
  };

  const handlePrev = () => {
    setError(""); // Clear error on navigating back
    setPage(page - 1);
  };

  const handleSubmit = () => {
    // Validate if an answer exists for the last question
    if (answers[questions[page - 1]?.question] === undefined) {
      setError("Please select an option to proceed.");
      return;
    }
    const totalScore = Object.values(answers).reduce((acc, val) => acc + Number(val), 0);
    setScore(totalScore);
    setPage(questions.length + 1);
  };

  const getResultCategory = (score) => {
    if (score <=10)
      return { level: "Toxin Level – Low", message: "Well done! Your lifestyle is great and fighting the toxins at optimum level. Keep it up." };
    if (score >= 11 && score <= 25)
      return { level: "Toxin Level – Moderate", message: "You are doing better than average but can improve a lot with better lifestyle choices." };
    if (score >= 26 && score <= 50)
      return { level: "Toxin Level – High", message: "Constant accumulation of toxins in body. Focus on adopting healthier dietary, recreational, and work-out routine." };
        if (score >= 51&& score <= 75)
      return { level: "Toxin Level – Excess", message: "Excess amount of toxins in body. Urgent need to adopt healthier diet , life routine." };

    if(score>50)
    return { level: "Toxin Level – Severe", message: "High amount of toxins in your body. Intervene urgently to make changes in your diet, work-out, and other lifestyle activities to avoid worsening of health." };
  };
  const { level, message } = getResultCategory(score);

  // Calculate progress based on the current question (page 1 to questions.length)
  const progressPercentage =
    page > 0 && page <= questions.length ? (page / questions.length) * 100 : 0;

  return (
    <div className="min-h-screen bg-light px-6 py-10 flex flex-col items-center text-center">
{page === 0 ? (
  /* INTRO PAGE */
  <div
    className="
      relative
      overflow-hidden
      rounded-[34px]
      max-w-5xl
      w-full
      h-[620px]
      shadow-[0_30px_80px_rgba(20,10,0,.12)]
    "
  >
    <img
      src="/assets/knowyourself/quiz/toxin.jpg"
      alt="Body Toxin Quiz"
      className="
        w-full
        h-full
        object-cover
        brightness-[.84]
        saturate-[.9]
      "
    />

    <div
      className="
        absolute
        inset-0
        bg-gradient-to-t
        from-black/90
        via-black/35
        to-transparent
      "
    />

    <div className="absolute inset-x-0 bottom-0 p-6">
      <div
        className="
          rounded-[28px]
          bg-white/10
          backdrop-blur-2xl
          border
          border-white/10
          p-8
        "
      >
        <div
          className="
            inline-flex
            px-4
            py-2
            rounded-full
            bg-white/10
            backdrop-blur-xl
            border
            border-white/10
            text-white
            text-xs
            tracking-[.08em]
            mb-5
          "
        >
          WELLNESS ASSESSMENT
        </div>

        <h1
          className="
            text-[38px]
            md:text-[56px]
            leading-[1.05]
            text-white
            mb-5
          "
        >
          {quizData.title}
        </h1>

        <p
          className="
            text-white/75
            text-[15px]
            leading-8
            mb-8
            max-w-3xl
          "
        >
          {quizData.description}
        </p>

        <Button
          variant="primary"
          size="md"
          text="Start Assessment"
          onClick={() => setPage(1)}
        />
      </div>
    </div>
  </div>

) : page <= questions.length ? (

  /* QUIZ PAGE */
  <div className="w-full max-w-4xl">
    <div className="bg-white rounded-[28px] p-8 shadow-xl">
      <div className="mb-8">
        <div className="flex justify-between mb-3">
          <span className="text-sm text-gray-500">
            Question {page} of {questions.length}
          </span>

          <span className="text-sm text-primary">
            {Math.round(progressPercentage)}%
          </span>
        </div>

        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full"
            style={{
              width: `${progressPercentage}%`,
            }}
          />
        </div>
      </div>

      <div className="mb-4 text-primary text-sm font-semibold">
        {questions[page - 1].category}
      </div>

      <h2 className="text-2xl text-secondary mb-8">
        {questions[page - 1].question}
      </h2>

      <div className="grid gap-4">
        {questions[page - 1].options.map(
          (option, idx) => (
            <button
              key={idx}
              onClick={() =>
                handleOptionChange(
                  questions[page - 1].question,
                  idx + 1
                )
              }
              className={`p-4 rounded-2xl border transition-all text-left ${
                answers[
                  questions[page - 1].question
                ] ===
                idx + 1
                  ? "bg-primary text-white border-primary"
                  : "bg-white hover:border-primary"
              }`}
            >
              {option}
            </button>
          )
        )}
      </div>

      {error && (
        <p className="mt-4 text-red-500">
          {error}
        </p>
      )}

      <div className="flex justify-between mt-8">
        {page > 1 && (
          <Button
            text="Previous"
            variant="whitish"
            onClick={handlePrev}
          />
        )}

        <Button
          text={
            page === questions.length
              ? "Submit"
              : "Next"
          }
          variant="primary"
          onClick={
            page === questions.length
              ? handleSubmit
              : handleNext
          }
        />
      </div>
    </div>
  </div>

) : (

  /* RESULT PAGE */
  <div
    className="
      relative
      overflow-hidden
      rounded-[34px]
      max-w-5xl
      w-full
      h-[620px]
      shadow-[0_30px_80px_rgba(20,10,0,.12)]
    "
  >
    <img
      src="/assets/knowyourself/quiz/result.jpg"
      alt="Results"
      className="
        w-full
        h-full
        object-cover
        brightness-[.84]
        saturate-[.9]
      "
    />

    <div
      className="
        absolute
        inset-0
        bg-gradient-to-t
        from-black/90
        via-black/35
        to-transparent
      "
    />

    <div className="absolute inset-x-0 bottom-0 p-6">
      <div
        className="
          rounded-[28px]
          bg-white/10
          backdrop-blur-2xl
          border
          border-white/10
          p-8
        "
      >
        <div
          className="
            inline-flex
            px-4
            py-2
            rounded-full
            bg-white/10
            backdrop-blur-xl
            border
            border-white/10
            text-white
            text-xs
            tracking-[.08em]
            mb-5
          "
        >
          YOUR RESULT
        </div>

        <h2
          className="
            text-[42px]
            md:text-[58px]
            text-white
            mb-5
          "
        >
          {level}
        </h2>

        <p
          className="
            text-white/75
            text-[15px]
            leading-8
            mb-8
            max-w-3xl
          "
        >
          {message}
        </p>

        <Button
          variant="primary"
          text="Retake Assessment"
          onClick={() => {
            setAnswers({});
            setScore(0);
            setPage(0);
          }}
        />
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default BodyToxinQuiz;
